import { action, observable } from 'mobx';
import { bookingApi } from '@link/agent/services';

export class Booking {
  @observable accessor loading = false;

  @action
  setLoading(loading: boolean) {
    this.loading = loading;
  }

  @action
  async getReservations() {
    this.setLoading(true);
    return bookingApi.listReservations().finally(() => {
      this.setLoading(false);
    });
  }

  @action
  async cancelReservations(bookingSessionIds: string[]) {
    return bookingApi.cancelReservations({ body: { bookingSessionIds } });
  }
}

export default new Booking();
